import React from 'react';
import ArrowIcon from '../Assests/Wellness/arrow.png'
import Women from '../Assests/Wellness/Women_vector.png';
import Man from '../Assests/Wellness/gastric_wellness.png';
import LeftImg1 from '../Assests/Diabetes/left_vector.png';
import RightImg2 from '../Assests/Diabetes/right_vector.png'


const page1 = () => {
    return (
        <div className='well-page1-container'>
            <div className='well-page1-img1-container'>
                <img src={LeftImg1} className='well-page1-img1'></img>
            </div>
           <div className='well-page1-content'>
                <p>Clinical Study on wellness</p>
                <p>Are Gastric, Metabolic, or Hormonal changes impacting your well-being?</p>
                <p>We’re inviting participants to join a clinical study that targets digestive, metabolic and women's health issues. The study helps identify the root cause of your imbalances and address it with personalized, evidence-based care.</p>
                <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLSeI4GC_CLiGldUlTyvXmDyzr1_fgKPjQvTX-RNijpPnx62IMg/viewform?usp=header" 
                target="_blank" 
                rel="noopener noreferrer"
                >
                <button className="button-wellness">
                    <img src={ArrowIcon} className="w-10 h-10" />
                    Express Interest
                </button>
                </a>
      
           </div>
           <div >
                <img src={RightImg2} className='well-page1-img2'></img>
           </div>
        </div>
    )
} 
export default page1;